<template>
  <LayoutContainer>
    <Header />
    <main class="flex-1">
      <slot />
    </main>
    <Footer />
  </LayoutContainer>
</template>
